import { render, staticRenderFns } from "./ModalKDSOrderDetails.vue?vue&type=template&id=5deba78e&scoped=true"
import script from "./ModalKDSOrderDetails.vue?vue&type=script&lang=js"
export * from "./ModalKDSOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./ModalKDSOrderDetails.vue?vue&type=style&index=0&id=5deba78e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deba78e",
  null
  
)

export default component.exports